import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatFormField, MatIcon } from '@angular/material';

@Component({
  selector: 'prgov-transaction-item',
  templateUrl: './transaction-item.component.html',
  styleUrls: ['./transaction-item.component.scss'],
})
export class TransactionItemComponent implements OnInit {
  @Input() type = '';
  @Input() removeActionBtn = false;
  @Input() btnLabel = 'Action';
  @Input() isAdmin = false;
  @ViewChild('messageInpt', { static: false }) textarea: ElementRef;

  requiredActionSelected: any;
  requiredActions: any[] = [
    { value: 1, name: 'Revisado (Completado)' },
    { value: 2, name: 'Solicitante necesita revisar' },
  ];

  needRevision = false;
  constructor() {}

  ngOnInit() {}

  requiredActionChange() {
    this.needRevision = this.requiredActionSelected === 2 ? true : false;
  }

  reset() {
    this.requiredActionSelected = null;
    this.needRevision = false;
  }
}
